import Konva from "konva";
import { collapseIndexForPanelPage, resetPanelShowForPanelPage } from '../../store/senAppProjects.action';
import { DrawFence } from '../fence/DrawFence';
import { PanelAutofillArea } from "../input/PanelAutofillArea";
import { SC_Input } from '../input/SC_Input';
import DrawPanels from "../konva/drawPanels";
import * as konva from "../konva/getCanvas";
import { getHgroups } from "../mountsys/PanelRowManager";
import { Sol50 } from '../mountsys/Sol50';
import { RoofShape } from "../roof/RoofShape";
import { Global } from "../utilities/global";
import checkForInvalid from "./checkForInvalidPanels";
import { DrawRoofForPanel } from "./drawRoofForPanel";
import { ModGroup } from "./ModGroup";
import { ModList } from "./ModList";
import { ModulProp } from './ModulProp';
import SnapPanel from "./panelssnap";
import genaratePanelSave from './savePanelDetails';

export class Modul {
	public iOrientation: number;
	public bSelected: boolean;
	//distance to dragged one
	public nDDisX: number;
	public nDDisY: number;
	public nStartDragX: number;
	public nStartDragY: number;
	public iGroup: number;
	public iInvalid: number;
	// Cantilever flag
	public iCantilever: number;

	public width: number;
	public height: number;
	public x: number;
	public y: number;
	public panelId: string;
	public static panelCount: number = 0;
	static cancelBubble: boolean = false;
	static isPanelMoving: boolean = false;
	static onSelectedPanel: boolean = false;
	static isPanelMoved: boolean = false;
	// public layer: Konva.Layer;

	constructor(x: number, y: number, w: number, h: number) {
		this.width = w;
		this.height = h;
		this.x = x;
		this.y = y;

	}

	public initImages(): void {

	}
	/**
	 *  drawGroup
	 */
	static drawPanelsFromSaved(group: any) {
		const allPanels: any = [];
		group.forEach((panel: any) => {
			let count = 0;
			let w = SC_Input.nModWidth / 10;
			let h = SC_Input.nModHeight / 10;
			if (panel.portrait == ModulProp.ORIENTATION_VERTICAL) {
				// SC_Input.iModAlignment == ModulProp.ORIENTATION_VERTICAL;
				w = SC_Input.nModWidth / 10;
				h = SC_Input.nModHeight / 10;
			} else {
				// SC_Input.iModAlignment == ModulProp.ORIENTATION_HORIZONTAL;
				w = SC_Input.nModHeight / 10;
				h = SC_Input.nModWidth / 10;
			}
			let x = panel.x;
			let y = panel.y;
			while (count < panel.panelCount) {
				x = (w + Sol50.nHorizontalAbstand) * count + panel.x;
				// new Modul(x, y, w, h).draw(DrawRoofForPanel.panelGroup);
				allPanels.push({ x: x, y: y, w: w, h: h });
				count++;
			}
		})
		new DrawPanels().drawPanels(allPanels);
	}
	static drawAllPanels(list?: any[]) {

	}

	public draw(layer: any): void {
		this.panelId = "panel" + Modul.panelCount;
		// ModList.listOfModules.push(this);
		Modul.panelCount++;
		var angle = 0;
		// if (SC_Input.iModAlignment == ModulProp.ORIENTATION_HORIZONTAL) {
		// 	angle = 90;
		// 	konva.getCanvasImage(this.x + this.height, this.y, this.height, this.width, layer, angle, this.panelId);
		// } else {
		// 	konva.getCanvasImage(this.x, this.y, this.width, this.height, layer, angle, this.panelId);
		// }
		konva.getCanvasImage(this.x, this.y, this.width, this.height, layer, angle, this.panelId);
	}

	public drawForString(layer: any): void {
		this.panelId = "panel" + Modul.panelCount;
		Modul.panelCount++;
		var angle = 0;
		konva.getPanelForStings(this.x, this.y, this.width, this.height, layer);
	}
	public drawHover(): void {

	}
	public drawSelected(): void {

	}

	// Remove all panels form roof 
	static clearAllPanels() {
		DrawRoofForPanel.panelGroup.removeChildren();
		if (ModGroup.currentSelectedGroup) ModGroup.currentSelectedGroup.destroy();
		const g: any = DrawRoofForPanel.layerPanel.find(".panelGroupSelected");
		if (g && g.length > 0) g.forEach((i: any) => {
			i.destroy();
		})
	}

	// can Til Ever Error drawing for panel
	public drawKragarm(): void {
		const temp: any = DrawRoofForPanel.stage.find("." + Global.panelsOnRoof);
		temp.forEach((panel: any) => {
			if (panel.getAttrs().id == this.panelId) {
				var a = panel.find('.canTilEver')[0];
				a.opacity(1);
			}
		});
	}

	public drawCurrent(): void {
		if (this.bSelected) {
			this.drawSelected();
		} else {
			// this.draw();
		}
	}
	public static deselection(): void {
		ModList.currentSelectedPanel.on('mousedown', (e: any) => {
			e.cancelBubble = false;
		});
		ModList.currentSelectedPanel.setDraggable(false);
		const a = ModList.currentSelectedPanel.find('.border');
		if (a && a[0]) a[0].opacity(0);
		ModList.currentSelectedPanel = null;
	}
	static removeSelection(): void {
		ModList.listOfModules.forEach((panel: any) => {
			if (panel.draggable) {
				const pObj: any = DrawRoofForPanel.layerPanel.find('#' + panel.id)[0];
				pObj.setDraggable(false);
				const a = pObj.find('.border');
				if (a && a[0]) a[0].opacity(0);
			}
		});
		ModList.currentSelectedPanel = null;
		DrawFence.removeTransformNodes();
	}

	// basic function which checks is shapes are touched each other 
	static haveIntersection(r1: any, r2: any) {
		return !(
			r2.x > r1.x + r1.width ||
			r2.x + r2.width < r1.x ||
			r2.y > r1.y + r1.height ||
			r2.y + r2.height < r1.y
		);
	}
	/**
	 * bind Events For panels
	 */
	public static bindEventsForModule(panel: any) {
		// panel.setDragBoundFunc
		var layer: any = DrawRoofForPanel.layerPanel;
		let start = { x: 120, y: 120 };
		let shape: any = null;
		let listOfGroups = ModList.listOfGroups;
		const roofW = RoofShape.getCurrentRoofWidth() - 20;
		const roofH = RoofShape.getCurrentRoofHeight() - 20;
		panel.on('dragstart', function (e: any) {
			start.x = e.target.attrs.x;
			start.y = e.target.attrs.y;
			e.cancelBubble = true;
			Modul.isPanelMoving = true;
			listOfGroups = getHgroups();
			// console.log(listOfGroups)
		});

		panel.on('dragmove', (e: any) => {
			// if(shape) shape.destroy()
			e.cancelBubble = true;
			let foundMatch = false;
			layer.find('.guid-line').destroy();

			if (listOfGroups && listOfGroups.length > 1) {
				const pAttrs = panel.getAttrs();
				// console.log(listOfGroups)
				const diffYs: any[] = listOfGroups.map((item: any) => { return Math.abs(item[0].y - pAttrs.y) });
				const cloneDiff: any[] = [...diffYs].sort();
				const groupsNearBy = cloneDiff.map((num: any) => {
					const index = diffYs.indexOf(num);
					diffYs[index] = null;
					return listOfGroups[index];
				})
				groupsNearBy.forEach((i: any) => {
					if (i.length == 1 && panel.getId() == i[0].id) {
					} else if (!foundMatch) {
						const values = SnapPanel.snapCal(i, pAttrs);
						if (values.x > 20 && values.y > 20) {
							foundMatch = true;
							if (shape == null) {
								shape = konva.getCanvasRect({
									x: values.x,
									y: values.y,
									width: values.w,
									height: values.h,
									fill: "rgb(255, 255, 255,0.5)",
								});
								// shape.moveToBottom();
								// shape.zIndex();
								// shape.moveDown();
								DrawRoofForPanel.layerRoof.add(shape);
								// DrawRoofForPanel.layerPanel.add(shape);
								shape.draw();
							} else {
								shape.x(values.x);
								shape.y(values.y);
							}
						} else {
							if (shape) shape.destroy();
							shape = null;
						}
					}
				});
				// snap 
				let allPanels: any = DrawRoofForPanel.layerPanel.find("." + Global.panelsOnRoof);
				if (allPanels.length > 1 && shape == null) {
					// clear all previous lines on the screen
					layer.find('.guid-line').destroy();
					// find possible snapping lines
					var lineGuideStops = this.getLineGuideStops(e.target);
					// find snapping points of current object
					var itemBounds = this.getObjectSnappingEdges(e.target);
					// now find where can we snap current object
					var guides = this.getGuides(lineGuideStops, itemBounds);
					// do nothing of no snapping
					if (!guides.length) {
						return;
					}
					this.drawGuides(guides);
					var absPos = e.target.absolutePosition();
					// now force object position
					guides.forEach((lg: any) => {
						switch (lg.snap) {
							case 'start': {
								switch (lg.orientation) {
									case 'V': {
										absPos.x = lg.lineGuide + lg.offset;
										break;
									}
									case 'H': {
										absPos.y = lg.lineGuide + lg.offset;
										break;
									}
								}
								break;
							}
							case 'end': {
								switch (lg.orientation) {
									case 'V': {
										absPos.x = lg.lineGuide + lg.offset;
										break;
									}
									case 'H': {
										absPos.y = lg.lineGuide + lg.offset;
										break;
									}
								}
								break;
							}
						}
					});
					e.target.absolutePosition(absPos);
				}
				if (shape) {
					const targetRect = shape.getAttrs();
					let overlapping = false;
					let allPanels: any = DrawRoofForPanel.layerPanel.find("." + Global.panelsOnRoof);
					allPanels.forEach((group: any) => {
						if (group.getAttrs().id != e.target.getAttrs().id) {
							if (this.haveIntersection(group.getAttrs(), targetRect)) {
								overlapping = true;
							}
						}
					});
					if (overlapping) {
						shape.destroy();
						shape = null;
					}
				}
			}
			DrawRoofForPanel.layerPanel.batchDraw();
			DrawRoofForPanel.layerRoof.batchDraw();
		});
		panel.on('dragend', (e: any) => {
			Modul.isPanelMoved = true;
			Modul.isPanelMoving = false;
			e.cancelBubble = true;
			layer.find('.guid-line').destroy();
			layer.batchDraw();
			const tx = e.target.getX() - 100;
			const ty = e.target.getY() - 100;
			const tw = e.target.getWidth();
			const th = e.target.getHeight();
			const target = e.target;
			const targetRect = e.target.getClientRect();
			const targetDetails = { ...e.target.getAttrs() };
			if (shape) {
				targetRect.x = shape.x() * DrawRoofForPanel.currentScale;
				targetRect.y = shape.y() * DrawRoofForPanel.currentScale;
				targetDetails.x = shape.x();
				targetDetails.y = shape.y();
				// shape.destroy();
			}
			let overlapping = false;
			let allPanels: any = DrawRoofForPanel.layerPanel.find("." + Global.panelsOnRoof);
			allPanels.forEach((group: any) => {
				if (group.getAttrs().id != target.getAttrs().id) {
					if (this.haveIntersection(group.getAttrs(), targetDetails)) {
						overlapping = true;
						// overlapedPanels.push(group);
					}
				}
			});
			const nonUsableArea: any = DrawRoofForPanel.layerPanel.find("." + Global.nonUsableArea);
			if (nonUsableArea && nonUsableArea.length > 0 && !overlapping) {
				overlapping = !DrawFence.isEligibletoDraw(targetDetails);
			}
			if (tx < 20 || ty < 20) { //} || (tx + tw) > roofW || (ty + th) > roofH) {
				overlapping = true;
			}
			if (overlapping) {
				target.setX(start.x);
				target.setY(start.y);
			} else {
				if (shape) {
					target.setX(shape.x());
					target.setY(shape.y());
				}
			}
			if (shape) {
				shape.destroy();
			}
			DrawRoofForPanel.layerRoof.batchDraw();
			DrawRoofForPanel.layerPanel.batchDraw();
			setTimeout(() => {
				// DrawRoofForPanel.elipseGroup.opacity(1);
				DrawRoofForPanel.layerPanel.batchDraw();
				genaratePanelSave();
				if (SC_Input.iPnlFillArea != PanelAutofillArea.ALL)
					checkForInvalid(panel);
			}, 1);
		});// drag end
		panel.on('mouseover', (event: any) => {
			if (!DrawRoofForPanel.isSubframeEnabled) {
				event.currentTarget.find('.border1')[0].opacity(1);
				DrawRoofForPanel.layerPanel.batchDraw();
			}
		});
		panel.on('mouseout', (event: any) => {
			if (!DrawRoofForPanel.isSubframeEnabled) {
				event.currentTarget.find('.border1')[0].opacity(0);
				DrawRoofForPanel.layerPanel.batchDraw();
			}
		});
		panel.on('click', (event: any) => {
			DrawFence.storeObj.dispatch(resetPanelShowForPanelPage({ resetPanelShow: false }));
			event.cancelBubble = true;
			// console.log(DrawRoofForPanel.stage.getDraggable());
			if (!DrawRoofForPanel.stage.getDraggable()) {
				DrawFence.storeObj.dispatch(collapseIndexForPanelPage({ collapseIndex: 1 }));
				DrawFence.removeTransformNodes();
				if (ModList.currentSelectedPanel) this.deselection();
				if (ModGroup.currentSelectedGroup) ModGroup.moveBackToMainGroup();

				event.currentTarget.setDraggable(true);
				event.currentTarget.find('.border')[0].opacity(1);
				ModList.currentSelectedPanel = event.currentTarget;
				ModList.currentSelectedPanel.moveToTop();
				ModList.currentSelectedPanel.on('mousedown', (e: any) => {
					e.cancelBubble = true;
				});
				DrawRoofForPanel.layerPanel.batchDraw();
			}
		});

		// panel.on('mousedown', function (event: any) {

		// 	// event.cancelBubble = true;
		// 	// // console.log(DrawRoofForPanel.stage);
		// 	// if (ModList.currentSelectedPanel) {
		// 	// 	ModList.removeSelection();
		// 	// }
		// 	// DrawFence.removeTransformNodes();
		// 	// event.currentTarget.setDraggable(true);
		// 	// event.currentTarget.find('.border')[0].opacity(1);
		// 	// ModList.currentSelectedPanel = event.currentTarget;
		// 	// DrawRoofForPanel.layerPanel.draw();
		// });
		// panel.on("mousedown mousemove mouseup", (evt: any) => {
		//     // evt.cancelBubble = true;
		// });
	}
	static removeEclipseError() {
		let allErrors: any = DrawRoofForPanel.layerPanel.find('.eclipseError');
		allErrors.forEach((i: any) => {
			i.destroy()
		});
	}

	// while Panels are moving on roof its suggest position with Guid lines
	static drawGuides(guides: any) {
		var layer: any = DrawRoofForPanel.layerPanel;

		guides.forEach((lg: any) => {
			if (lg.orientation === 'H') {
				var line = new Konva.Line({
					points: [-6000, 0, 6000, 0],
					stroke: '#ffffff',//'rgb(0, 161, 255)',
					strokeWidth: 3,
					name: 'guid-line',
					dash: [4, 6],
				});
				layer.add(line);
				line.absolutePosition({
					x: 0,
					y: lg.lineGuide,
				});
				layer.batchDraw();
			} else if (lg.orientation === 'V') {
				var line = new Konva.Line({
					points: [0, -6000, 0, 6000],
					stroke: '#ffffff',//'rgb(0, 161, 255)',
					strokeWidth: 3,
					name: 'guid-line',
					dash: [4, 6],
				});
				layer.add(line);
				line.absolutePosition({
					x: lg.lineGuide,
					y: 0,
				});
				layer.batchDraw();
			}
		});
	}

	// Guid lines
	// find all snapping possibilities
	static getGuides(lineGuideStops: any, itemBounds: any) {
		var resultV: any = [];
		var resultH: any = [];
		var GUIDELINE_OFFSET = 5;

		lineGuideStops.vertical.forEach((lineGuide: any) => {
			itemBounds.vertical.forEach((itemBound: any) => {
				var diff = Math.abs(lineGuide - itemBound.guide);
				// if the distance between guild line and object snap point is close we can consider this for snapping
				if (diff < GUIDELINE_OFFSET) {
					resultV.push({
						lineGuide: lineGuide,
						diff: diff,
						snap: itemBound.snap,
						offset: itemBound.offset,
					});
				}
			});
		});

		lineGuideStops.horizontal.forEach((lineGuide: any) => {
			itemBounds.horizontal.forEach((itemBound: any) => {
				var diff = Math.abs(lineGuide - itemBound.guide);
				if (diff < GUIDELINE_OFFSET) {
					resultH.push({
						lineGuide: lineGuide,
						diff: diff,
						snap: itemBound.snap,
						offset: itemBound.offset,
					});
				}
			});
		});

		var guides = [];

		// find closest snap
		var minV = resultV.sort((a: any, b: any) => a.diff - b.diff)[0];
		var minH = resultH.sort((a: any, b: any) => a.diff - b.diff)[0];
		if (minV) {
			guides.push({
				lineGuide: minV.lineGuide,
				offset: minV.offset,
				orientation: 'V',
				snap: minV.snap,
			});
		}
		if (minH) {
			guides.push({
				lineGuide: minH.lineGuide,
				offset: minH.offset,
				orientation: 'H',
				snap: minH.snap,
			});
		}
		return guides;
	}

	// Guid lines
	// what points of the object will trigger to snapping?
	// it can be just center of the object
	// but we will enable all edges and center
	static getObjectSnappingEdges(node: any) {
		var box = node.getClientRect();
		var absPos = node.absolutePosition();

		return {
			vertical: [
				{
					guide: (box.x),
					offset: (absPos.x - box.x),
					snap: 'start',
				},
				{
					guide: (box.x + box.width),
					offset: (absPos.x - box.x - box.width),
					snap: 'end',
				},
			],
			horizontal: [
				{
					guide: (box.y),
					offset: (absPos.y - box.y),
					snap: 'start',
				},
				{
					guide: (box.y + box.height),
					offset: (absPos.y - box.y - box.height),
					snap: 'end',
				},
			],
		};
	}

	// were can we snap our objects?
	static getLineGuideStops(skipShape: any) {
		var stage = DrawRoofForPanel.stage;
		// we can snap to stage borders and the center of the stage
		var vertical: any = [0, stage.width() / 2, stage.width()];
		var horizontal: any = [0, stage.height() / 2, stage.height()];

		// and we snap over edges and center of each object on the canvas
		var objs: any = stage.find("." + Global.panelsOnRoof);
		objs.forEach((guideItem: any) => {
			if (guideItem === skipShape) {
				return;
			}
			var box: any = guideItem.getClientRect();
			// and we can snap to all edges of shapes
			vertical.push([box.x, box.x + box.width]);
			horizontal.push([box.y, box.y + box.height]);
		});
		return {
			vertical: vertical.flat(),
			horizontal: horizontal.flat(),
		};
	}
}

function pointIsInRange(p: number, q: number, obj: any): boolean {
	if (obj && obj.getAttrs()) {
		var x = obj.getAttrs().x;
		var y = obj.getAttrs().y;
		var w = obj.getAttrs().width;
		var h = obj.getAttrs().height;
		if (p >= x && p <= x + w && q >= y && q <= y + h) {
			return true;
		}
	}
	return false;
}
